(function(window, undefined) {
	'use strict';
	var DeskSrvc = function() {
		this.isDesk = false;
	};

	DeskSrvc.$inject = [];

	angular.module('cbl.finanza.mf').service('FinDeskSrvc', DeskSrvc);
}(window));


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/servicesUtilities/finDeskSrvc.js
 ** module id = 21
 ** module chunks = 0 1
 **/